import React from 'react';
import { prepareData } from 'utils/googleData';
import { LinkedIn } from 'components/Icons/Icons';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export const Speakers = (props) => {
    const {
        enable,
        items,
        title,
        direction
    } = prepareData({ props });

    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return null;
    }

    return (
        <div direction={direction} className="mx-5 mt-6 sm:mx-0 sm:mt-8">
            <h3 className="text-2xl font-semibold mb-4">{title}</h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {items?.length > 0 && items.map((speakerInfo) => {
                    const name = speakerInfo?.frontmatter?.name || speakerInfo?.name;
                    const title = speakerInfo?.frontmatter?.title || speakerInfo?.title;
                    const company = speakerInfo?.frontmatter?.company || speakerInfo?.company;
                    const linkedin = speakerInfo?.frontmatter?.linkedin || speakerInfo?.linkedin;
                    console.log(speakerInfo);
                    const speakerImage = speakerInfo?.gatsbyImage;

                    return (
                        <li key={name} className="text-center">
                            {speakerImage && (
                                <GatsbyImage image={speakerImage} alt={`Picture of ${name}`} className="rounded-full w-32 h-32 mx-auto mb-3" />
                            )}
                            <h5 className="text-lg font-bold">{name}</h5>
                            <p className="text-sm opacity-75">{title}<br />{company}</p>
                            {linkedin && (
                                <a href={linkedin} target="_blank" rel="noopener noreferrer" className="mt-3 inline-block text-blue-500 hover:text-blue-600">
                                    <LinkedIn className="h-5 w-5" />
                                </a>
                            )}
                        </li>
                    )
                })}
            </ul>
        </div>
    );
};

export default Speakers;
